import { render, staticRenderFns } from "./TabProduct.vue?vue&type=template&id=16416f60&"
import script from "./TabProduct.vue?vue&type=script&lang=js&"
export * from "./TabProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports